import React, { Component } from 'react';
import { Switch, Route } from 'react-router-dom';
import { Link, BrowserRouter as Router } from 'react-router-dom';
import NLPEntitiesMainTab from './NLPEntitiesMainTab';
import $ from 'jquery';
class NLPMultiLingualTabs extends Component {
  componentDidMount() {
    (function () {
      var currentPath = window.location.href;
      var currentPath = window.location.href;
      var path = window.origin + "/platform/cloud-nlp/entities";
      var path1 = window.origin + "/platform/cloud-nlp/entitiesl/";
      if (currentPath === path || currentPath === path1) {
        $("#entities-tab").addClass('active');
      } else {
        $("#" + localStorage.getItem("last-multilingual-data-tab")).addClass('active')
      }
      $("#entities-tab")
        .on("click", function () {
          $("#entities-tab")
            .removeClass('active');
          localStorage.setItem("last-multilingual-data-tab", $(this)[0].id);
          $(this).addClass('active')

        })


    })();
  }
  render() {
    return (
      <Router basename={window.contextPath}>
        <div id="tabPage" >
          <div className="content" >

            <link rel="shortcut icon" type="image/png" href="assets/images/bot.ico" />
            <title> Dheeyantra | Clusters Details</title>
            {/* Font Awesome Icons */}
            <link rel="stylesheet" href="plugins/font-awesome/css/font-awesome.min.css" />
            {/* IonIcons */}
            <link rel="stylesheet" href="//code.ionicframework.com/ionicons/2.0.1/css/ionicons.min.css" />
            <link rel="stylesheet" href="assets/fonts/flat-icon/flaticon.css" />
            {/* Theme style */}
            <link rel="stylesheet" href="assets/css/adminlte.css" />
            <link href="https://cdn.jsdelivr.net/npm/gijgo@1.9.6/css/gijgo.min.css" rel="stylesheet" />
            <link rel="stylesheet" href="assets/css/custom-style.css" />
            <link rel="stylesheet" href="assets/css/styles.css" />
            <link rel="stylesheet" href="assets/css/custom-style.css" />
            <div className="content-header" >
              <div className="container-fluid">
                <div className="row">
                  <div className="col-sm-5">
                    <h1 className="m-0 page-title">Entities </h1>
                    <h6 className="taglineTxt">Multilingual support for entities </h6>
                  </div>
                  {/* <div className="col-sm-7 p-0">
              <div className="d-flex flex-row-reverse pt-2">
                <button type="button" className="btn btn-primary navyblue-btn pull-right mr-10">Save changes</button> */}
                  {/* <div class="refresh-icon">  <i class="fa flaticon-reload"></i></div> */}
                  {/* </div>
            </div> */}
                </div>
              </div>
            </div>
            <div className="container-fluid">
              <div className="border-bottom"></div>
              {/* Nav tabs */}
              <div className="tab-class">

                <ul className="nav nav-tabs border-bottom navCluster">
                  <Link className="nav-item" data-toggle="tab"
                    to="/projectmgmt/multilingual" style={{ textDecoration: 'none' }} >
                    <li className="nav-link" id="entities-tab">
                      Entities
                    </li>
                  </Link>




                </ul>
              </div>
            </div>
          </div>
          <Switch >
            <Route path="/cloud-nlp/entities" component={NLPEntitiesMainTab}></Route>
          </Switch>

        </div>
      </Router>
    );
  }
}
export default NLPMultiLingualTabs;


// WEBPACK FOOTER //
// ./src/nlpUi/NLPMultiLingualTabs.js